import { Typography } from '@mui/material'
import React from 'react'

export default function Footer() {
  return (
    <Typography>
        Copyright © 2021 Edward Russell Law
    </Typography>
  )
}
